
const GET_BALANCE_INFO = "getBalanceInfo";
const SET_BALANCE_INFO = "setBalanceInfo";
const GET_SERVER_TIME = "getServerTime";
const SET_SERVER_TIME = "setServerTime";
const SET_TOTAL_EQUITY = "setTotalEquity";
const GET_CUSTOMER_NEWS = "getCustomerNews";
const SET_CUSTOMER_NEWS = "setCustomerNews";
const SET_NTD_FX_MAINTENANCE = "setNtdFxMaintenance";


export {
  GET_SERVER_TIME,
  SET_SERVER_TIME,
  GET_BALANCE_INFO,
  SET_BALANCE_INFO,
  SET_TOTAL_EQUITY,
  GET_CUSTOMER_NEWS,
  SET_CUSTOMER_NEWS,
  SET_NTD_FX_MAINTENANCE,
};
